export * from './src/utils/page-listeners'

export function registerElement(name: string, constructor: CustomElementConstructor, options?: ElementDefinitionOptions): void {
    if (!customElements.get(name)) {
        customElements.define(name, constructor, options)
    }
}

export function registerStaticElement(name: string): void {
    if (!customElements.get(name)) {
        customElements.define(name, class extends HTMLElement {})
    }
}
